import { connect } from 'react-redux';
import { compose, hoistStatics, withState } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import Tawk from './Tawk';

const mapStateToProps = state => ({
  appID: state.modules.modulesSettings.tawk ? state.modules.modulesSettings.tawk.params.appId : '',
});

const enhance = compose(
  connect(mapStateToProps, null),
  withState('isLoading', 'setIsLoading', false),
  translate('portal'),
);

export default withRouter(hoistStatics(enhance)(Tawk));



// WEBPACK FOOTER //
// ./src/components/tawk/index.js